import { type Application, isWorkmanCardPassing } from "./types";

export interface KpiSet {
  totalReceived: number;
  pendingValidation: number;
  onHold: number;
  readyForIcici: number;
  readyForMou: number;
  awaitingSubcontractor: number;
  subcontractorLinked: number;
  seedingPendingBeforeIcici: number;
  billsPendingSeedingReverify: number;
  workmanOrNameIssues: number;
}

export function computeKpis(apps: Application[]): KpiSet {
  const totalReceived = apps.length;
  let pendingValidation = 0;
  let onHold = 0;
  let readyForIcici = 0;
  let readyForMou = 0;
  let awaitingSubcontractor = 0;
  let subcontractorLinked = 0;
  let seedingPendingBeforeIcici = 0;
  let billsPendingSeedingReverify = 0;
  let workmanOrNameIssues = 0;

  for (const a of apps) {
    if (a.status === "on_hold") onHold++;
    else if (a.status === "pending_validation") pendingValidation++;
    else if (a.status === "ready_for_icici") readyForIcici++;
    else if (a.status === "ready_for_mou") readyForMou++;
    else if (a.status === "icici_recorded") awaitingSubcontractor++;
    else if (a.status === "subcontractor_linked") subcontractorLinked++;

    const v = a.validations;
    const coreOk =
      v.nameMatchAcrossSources === true &&
      v.aadhaarVerified === true &&
      v.bankAccountVerified === true &&
      isWorkmanCardPassing(v.workmanCardAcceptable);
    if (coreOk && !v.aadhaarSeedingConfirmed && a.holdReasons.length === 0) {
      seedingPendingBeforeIcici++;
    }

    const pendingBills = a.workDoneBills.filter((b) => !b.seedingReVerified).length;
    billsPendingSeedingReverify += pendingBills;

    if (v.nameMatchAcrossSources === false || v.workmanCardAcceptable === false) {
      workmanOrNameIssues++;
    }
  }

  return {
    totalReceived,
    pendingValidation,
    onHold,
    readyForIcici,
    readyForMou,
    awaitingSubcontractor,
    subcontractorLinked,
    seedingPendingBeforeIcici,
    billsPendingSeedingReverify,
    workmanOrNameIssues,
  };
}

/** Re-export so dashboard (and other deep paths) can import leads API via `../../kpi`. */
export { fetchLeadsTable } from "./api/leadsTableApi";
